module.exports = __webpack_public_path__ + "img/401kai_adviser.e261135b.png";